var QawafilStoreFront = (function () {
    'use strict';

    var helpers = {
        blockPage: function () {
            $.blockUI({
                css: {border: 'none', backgroundColor: "rgba(0,0,0,0)", fontSize: '40px', color: "var(--mainColor)"},
                message: '<i class="fa fa-spinner fa-spin"></i>'
            });
        },
        unBlockPage: function () {
            $.unblockUI();
        },
        preventOnEnter: function(formId) {
            $(document).on('keypress', formId + ' input', function (event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    event.preventDefault();
                }
            });
        },
        registerScrollingLinks: function () {
            // Select all the links with the `js-scroll-to` class
            const scrollLinks = document.querySelectorAll('.js-scroll-to');

            scrollLinks.forEach(function(link) {
                link.addEventListener('click', function(event) {
                    event.preventDefault(); // Prevent the default anchor behavior

                    // Get the value of the data-scroll-to attribute
                    const targetSelector = link.getAttribute('data-scroll-to');
                    const targetElement = document.querySelector(targetSelector);

                    if (targetElement) {
                        // Smooth scroll to the target element
                        targetElement.scrollIntoView({ behavior: 'smooth' });
                    }
                });
            });
        },
        resetForm : function(formId){
            // formId including #
            $(formId).trigger("reset");
            try{
                // for images
                $(formId + ' img').attr('src', '');
                $(formId + ' [type="checkbox"]').attr("checked", null);

            }catch(error){

            }
        },
        showValidationErrors: function() {
        },
        getElement: function (element) {
            let elementQuerySelector = typeof element === 'object' ? element.querySelector : element;
            return document.querySelector(elementQuerySelector);
        },
        getFormDataAsObject: function (form){

            let formData = null;
            let object = {};

            if (form instanceof FormData) {
                formData = form;
            } else {
                formData = new FormData(helpers.getElement(form));
            }
            formData.forEach(function(value, key){
                object[key] = value;
            });
            return object;
        },
        getCurrencyIconHtml: function ()
        {
            // todo: the icon must be given as arg
            // when supporting currencies => we mustn't use this in scripts.. must update the code to preserve the currency and update nubmers only
            return "<span class='icon-sar' style='display:inline-block;'></span>";
        }


    }

    function registerGeneralEvents(){

        $('#contact_form').on('submit', function(e){
            e.preventDefault();
            let formData = new FormData($(this)[0]);
            let body = QawafilStoreFront.helpers.getFormDataAsObject(formData);
            Qawafil.contact.submit(body, function(response){
                if(response){
                    if( response.status)toastSuccess(response.message);
                    else if(response.code !== 403) toastError(response.message);
                }
                else{
                    toastError();
                }
            });
        });
    }


    function init() {
        helpers.registerScrollingLinks()
        registerGeneralEvents();
        QawafilStoreFrontAuth.init();
        QawafilStoreFrontCart.init();
        QawafilStoreFrontCustomer.init();
        QawafilStoreFrontProducts.initProductFilterPage();
        QawafilStoreFrontProducts.initProductCardEvents();
    }

    return {
        helpers: helpers,
        init: init
    };

})();
